import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  loadingView: {
    position: 'relative',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    marginHorizontal: 20,
  },
  loadingImage: {
    width: '100%',
  },
});
